module.exports = __webpack_public_path__ + "static/media/bgCreek.4ca1868a.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/bgCreek.png
// module id = 1263
// module chunks = 0